import { Injectable } from '@angular/core';
import { BaseService } from './base-service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { NodeActionDTO } from '../model/traceability/node-action-dto';
import { ThreatManagementDTO } from '../model/traceability/threat-management-dto';
import { NodeConfigurationTraceabilityDTO } from '../model/traceability/node-configuration-traceability-dto';


@Injectable({
    providedIn: 'root'
})
export class TraceabilityService extends BaseService {

    constructor(http: HttpClient, router: Router) {
        super(http, router)
    }

    getNodeConfigurationCount(nodeId: number): Promise<number> {
        let request = this.get<number>(`traceability/node-configurations/${nodeId}`);
        return this.apiCall<number>(request)
    }

    getNodeConfiguration(nodeId: number, index: number): Promise<NodeConfigurationTraceabilityDTO> {
        let request = this.get<NodeConfigurationTraceabilityDTO>(`traceability/node-configurations/${nodeId}/${index}`);
        return this.apiCall<NodeConfigurationTraceabilityDTO>(request)
    }

    getNodeActionCount(nodeId: number): Promise<number> {
        let request = this.get<number>(`traceability/node-actions/${nodeId}`);
        return this.apiCall<number>(request)
    }

    getNodeAction(nodeId: number, index: number): Promise<NodeActionDTO> {
        let request = this.get<NodeActionDTO>(`traceability/node-actions/${nodeId}/${index}`);
        return this.apiCall<NodeActionDTO>(request)
    }

    getThreatManagementCount(nodeId: number): Promise<number> {
        let request = this.get<number>(`traceability/threat-management/${nodeId}`);
        return this.apiCall<number>(request)
    }

    getThreatManagement(nodeId: number, index: number): Promise<ThreatManagementDTO> {
        let request = this.get<ThreatManagementDTO>(`traceability/threat-management/${nodeId}/${index}`);
        return this.apiCall<ThreatManagementDTO>(request)
    }

}
